<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Administra las bodegas donde guardas productos. Crea, edita o desactiva 
                almacenes y relaciónalos con plantas y oficinas. Úsalo para organizar el 
                inventario por ubicación.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Almacenes
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>almacenes</b> que operan dentro de AVE para una <b>planta</b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
      <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Almacenes</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo Registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
              mat-table
              [dataSource]="dataSource"
              matSort
              [trackBy]="trackByFn"
            >
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Nombre
                </th>
                <td mat-cell *matCellDef="let warehouse" class="text-sm uppercase">
                  <div *ngIf="getCode(warehouse) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ warehouse.name }}
                </td>
              </ng-container>

              <!-- Planta -->
              <ng-container matColumnDef="plant">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Planta
                </th>
                <td mat-cell *matCellDef="let warehouse" class="text-sm">
                  <!-- Mostrar el nombre de la planta y su ID -->
                  <div *ngFor="let plant of warehouse.plants">
                    {{ plant.name }}
                  </div>
                </td>
              </ng-container>

              <!-- Compania -->
              <ng-container matColumnDef="company">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Compañía
                </th>
                <td mat-cell *matCellDef="let warehouse" class="text-sm uppercase">
                  {{ warehouse.company.name }}
                </td>
              </ng-container>

                    <!-- Estado -->
                    <ng-container matColumnDef="readOnly">
                      <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                        Solo Lectura
                      </th>
                      <td mat-cell *matCellDef="let warehouse" class="px-6 text-left">
                        <mat-slide-toggle
                          class="custom-slide-toggle primary"
                          [checked]="warehouse.readOnly == true"
                          [(ngModel)]="warehouse.readOnly"
                          [color]="'success'"
                          (ngModelChange)="onreadStatusChange($event, warehouse)"
                        >
                        </mat-slide-toggle>
                      </td>
                    </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  Estado
                </th>
                <td mat-cell *matCellDef="let warehouse" class="px-6 text-left">
                  <mat-slide-toggle
                    class="custom-slide-toggle primary"
                    [checked]="warehouse.statusId == 1"
                    [(ngModel)]="warehouse.statusId"
                    [color]="'success'"
                    (ngModelChange)="onStatusChange($event, warehouse)"
                  >
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="px-6 py-3 text-left"
                ></th>
                <td
                  mat-cell
                  *matCellDef="let warehouse"
                  class="px-6 py-3 text-left"
                >
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="actionMenu"
                    matTooltip="Acciones"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(warehouse)">
                      <mat-icon
                        svgIcon="heroicons_outline:pencil-square"
                      ></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(warehouse)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"
              ></tr>

              <!-- Fila principal -->
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="border-b"
              ></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-xl font-bold mb-4 border-b">Nuevo Registro</h2>
      <mat-dialog-content class="overflow-y-auto max-h-full">
        <form #createForm="ngForm" class="space-y-8 flex flex-col">
          <app-form-section title="Información Básica" icon="inventory_2" iconColor="blue">
            <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Código</mat-label>
                <input
                  matInput
                  [(ngModel)]="currentCreateWarehouse.code"
                  name="code"
                  required
                />
                <mat-error *ngIf="!currentCreateWarehouse.code">Este campo es requerido</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  [(ngModel)]="currentCreateWarehouse.name"
                  name="name"
                  required
                />
                <mat-error *ngIf="!currentCreateWarehouse.name">Este campo es requerido</mat-error>
              </mat-form-field>
            </div>
          </app-form-section>

          <app-form-section title="Configuración de Precios" icon="attach_money" iconColor="green">
            <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
              <!-- Select Price List -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Precios</label>
                <ng-select
                  [(ngModel)]="currentCreateWarehouse.priceListId"
                  [items]="priceList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione una lista de precios"
                  name="priceListId"
                  [appendTo]="'body'"
                >
                  <!-- Personalizar la visualización de los ítems en la lista desplegable -->
                  <ng-template ng-label-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                </ng-select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Descuentos</label>
                <ng-select
                  [(ngModel)]="currentCreateWarehouse.discountListId"
                  [items]="discountList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione un precio de descuento"
                  name="discountListId"
                  [appendTo]="'body'"
                >
                  <!-- Personalizar la visualización de los ítems en la lista desplegable -->
                  <ng-template ng-label-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </app-form-section>

          <app-form-section title="Configuración Organizacional" icon="business" iconColor="purple">
            <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
              <!-- Select Compañía -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Compañía *</label>
                <ng-select
                  [(ngModel)]="currentCreateWarehouse.companyid"
                  [items]="companyList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione una compañía"
                  name="companyid"
                  [appendTo]="'body'"
                  required
                >
                </ng-select>
              </div>

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Plantas</mat-label>
                <mat-select
                  [formControl]="plantMultiCtrl"
                  placeholder="Seleccione plantas"
                  [multiple]="true"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [showToggleAllCheckbox]="true"
                      [toggleAllCheckboxIndeterminate]="isIndeterminate"
                      [toggleAllCheckboxChecked]="isChecked"
                      (toggleAll)="toggleSelectAll($event)"
                      [formControl]="plantMultiFilterCtrl"
                      [noEntriesFoundLabel]="'No se encontraron resultados'"
                      [placeholderLabel]="'Buscar plantas...'"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let plant of filteredPlants | async"
                    [value]="plant"
                  >
                    <b *ngIf="plant?.externalKeys?.code">{{ plant?.externalKeys?.code }}</b>{{ plant?.externalKeys?.code ? '-' : '' }}{{ plant.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </app-form-section>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end px-6 py-4 border-t">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="createWarehouse()"
          [disabled]="!createForm.valid"
        >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-xl font-bold mb-4 border-b">Editar Registro</h2>
      <mat-dialog-content class="overflow-y-auto max-h-full">
        <form #editForm="ngForm" class="space-y-8 flex flex-col">
          <app-form-section title="Información Básica" icon="inventory_2" iconColor="blue">
            <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Código</mat-label>
                <input
                  matInput
                  [(ngModel)]="currentUpdateWarehouse.externalKeys.code"
                  name="code"
                  disabled
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  [(ngModel)]="currentUpdateWarehouse.name"
                  name="name"
                  required
                />
                <mat-error *ngIf="!currentUpdateWarehouse.name">Este campo es requerido</mat-error>
              </mat-form-field>
            </div>
          </app-form-section>

          <app-form-section title="Configuración de Precios" icon="attach_money" iconColor="green">
            <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
              <!-- Select Price List -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Precios</label>
                <ng-select
                  [(ngModel)]="currentUpdateWarehouse.priceList"
                  [items]="priceList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione una lista de precios"
                  name="priceListId"
                  [appendTo]="'body'"
                  (ngModelChange)="onPriceSelectionChange($event)"
                  [compareWith]="compareById"
                >
                  <!-- Personalizar la visualización de los ítems en la lista desplegable -->
                  <ng-template ng-label-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                </ng-select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Descuentos</label>
                <ng-select
                  [(ngModel)]="currentUpdateWarehouse.discountList"
                  [items]="discountList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione un precio de descuento"
                  name="discountListId"
                  [compareWith]="compareById"
                  (ngModelChange)="onDiscountPriceSelectionChange($event)"
                  [appendTo]="'body'"
                >
                  <!-- Personalizar la visualización de los ítems en la lista desplegable -->
                  <ng-template ng-label-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </app-form-section>

          <app-form-section title="Configuración Organizacional" icon="business" iconColor="purple">
            <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Compañía *</label>
                <ng-select
                  [(ngModel)]="currentUpdateWarehouse.company"
                  [items]="companyList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione una compañía"
                  name="companyid"
                  [compareWith]="compareById"
                  (ngModelChange)="onCompanySelectionChange($event)"
                  [appendTo]="'body'"
                  required
                >
                </ng-select>
              </div>
              <!-- Select sub-route -->
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Plantas</mat-label>
                <mat-select
                  [formControl]="plantMultiCtrl"
                  placeholder="Seleccione plantas"
                  [multiple]="true"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [showToggleAllCheckbox]="true"
                      [toggleAllCheckboxIndeterminate]="isIndeterminate"
                      [toggleAllCheckboxChecked]="isChecked"
                      (toggleAll)="toggleSelectAll($event)"
                      [formControl]="plantMultiFilterCtrl"
                      [noEntriesFoundLabel]="'No se encontraron resultados'"
                      [placeholderLabel]="'Buscar plantas...'"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let plant of filteredPlants | async"
                    [value]="plant"
                  >
                    <!-- <b>{{ plant?.externalKeys?.code }}</b
                    >-{{ plant.name }} -->
                    <b *ngIf="plant?.externalKeys?.code">{{ plant?.externalKeys?.code }}</b>{{ plant?.externalKeys?.code ? '-' : '' }}{{ plant.name }}

                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </app-form-section>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end px-6 py-4 border-t">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="updateWarehouse(currentUpdateWarehouse._id)"
          [disabled]="!editForm.valid"
        >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- 
      El template deleteDialog ha sido reemplazado por el ConfirmationModalComponent
      Ver warehouse.component.ts - método openDeleteDialog()
    -->
  </div>

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="clearFilters()"
    (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters
      [form]="form"
      [company]="true"
      [plant]="true"
      [loadData]="loadFiltersData"></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>
